import React from "react";
import ApprovalList from "./ApprovalList";
import { formatJaDate } from "./dateUtil";

// 時間訂正 承認ページ（管理者）。共通の ApprovalList に列/カード/APIを渡すだけの薄い実装。
// 承認するとバックエンドが該当打刻へ new_value を反映し、old_value を履歴として保持する（労基対応）。
// 出勤–退勤をセットで「変更前→変更後」表示する。変わっていない側も併記し、何がどう変わったかを
// 一目で分かるようにする（打刻無し日など相方が無い側は「-」・#12）。
const pair = (i, o) => `${i || "-"} - ${o || "-"}`;

const CONFIG = {
  title: "時間訂正の承認",
  // NAV のキーと一致させる（経営者の承認の入口は勤怠履歴）。詳細は LeaveApprovalPage を参照。
  active: "attendance",
  listPath: "/api/employee/time-correction/list",
  decidePath: "/api/employee/time-correction/decide",
  fields: [
    { header: "社員", value: (r) => r.employee_name, nowrap: true, primary: true },
    { header: "対象日", value: (r) => (r.target_date ? formatJaDate(r.target_date) : "-"), nowrap: true },
    { header: "変更前", value: (r) => pair(r.in_before, r.out_before), nowrap: true },
    { header: "変更後", value: (r) => pair(r.in_after, r.out_after), nowrap: true },
    { header: "理由", value: (r) => r.reason || "-", muted: true, wrap: true },
  ],
};

function TimeCorrectionApprovalPage() {
  return <ApprovalList config={CONFIG} />;
}

export default TimeCorrectionApprovalPage;
